/*
  hp-breadcrumb-context
  ---------------------
  Makes a PDP's middle breadcrumb follow the collection the shopper actually
  came from, without collection-scoped product URLs.

  WHY THIS IS A SCRIPT AND NOT LIQUID. Shopify only populates the `collection`
  object on a /collections/<handle>/products/<handle> URL, and this store links
  to bare /products/<handle> everywhere on purpose. Liquid cannot read query
  parameters either, so once the URL carries no collection there is no
  server-side signal left. The referrer is the only one, and it is only readable
  in the browser.

  WHAT IT DELIBERATELY DOES NOT TOUCH: the served HTML and the BreadcrumbList
  structured data. Googlebot arrives with no referrer and never runs this path,
  so what gets indexed is always the trail snippets/hp-breadcrumbs.liquid
  rendered — the curated `hpl.breadcrumb_collection`, or the first non-catch-all
  collection. Curation for SEO is that metafield's job, not this file's.

  THE SWAP IS REFUSED UNLESS THE PRODUCT IS IN THE REFERRING COLLECTION. The
  server hands us the product's own non-catch-all collections; a referrer naming
  anything else is ignored. Without that check a shopper reaching a product from
  a collection it is not in (a promo grid, a search page under /collections)
  would get a crumb linking to a page that does not list what they are looking
  at.

  REFERRER, NOT sessionStorage. Storage would answer "the last collection seen
  this tab", which goes stale the moment the shopper passes through the homepage
  or the search panel on the way. The referrer answers the narrower question the
  crumb is actually asking, and stores nothing.
*/
(function () {
  'use strict';

  // Matches /collections/<handle> anywhere at the start of a path, so a locale
  // prefix (/en-ca/collections/candles), a pager segment (/page/2) and a filter
  // query all resolve to the same handle.
  var COLLECTION_PATH = /^(?:\/[a-z]{2}(?:-[a-z0-9]+)?)?\/collections\/([^\/?#]+)/i;

  // Consumed once, then cleared. sections/hp-main-product.liquid stashes the
  // real referrer here before redirecting away from a hidden variant, because
  // `location.replace` makes `document.referrer` the product itself and would
  // otherwise cost every such product the swap.
  var CARRIED = 'hp:crumb-referrer';

  function takeCarriedReferrer() {
    var value = null;
    try {
      value = sessionStorage.getItem(CARRIED);
      sessionStorage.removeItem(CARRIED);
    } catch (e) {
      return null;
    }
    return value;
  }

  function samePath(a, b) {
    try {
      var left = new URL(a, window.location.href);
      var right = new URL(b, window.location.href);
      return left.origin === right.origin && left.pathname === right.pathname;
    } catch (e) {
      return false;
    }
  }

  function referringCollectionHandle() {
    var ref = document.referrer;
    var carried = takeCarriedReferrer();

    // A referrer pointing at THIS product is the redirect's signature: no
    // ordinary navigation produces one. Compare PATHS, not full URLs — the
    // redirect lands on the same product with a ?variant= query, so the two
    // hrefs never match and an href comparison silently refuses every carry.
    if (carried && (!ref || samePath(ref, window.location.href))) {
      ref = carried;
    }

    if (!ref) return null;

    var url;
    try {
      url = new URL(ref, window.location.href);
    } catch (e) {
      return null;
    }

    // Same-origin only. A cross-origin referrer is usually stripped to the bare
    // origin anyway, and an off-site path is not our catalogue's.
    if (url.origin !== window.location.origin) return null;

    var match = COLLECTION_PATH.exec(url.pathname);
    if (!match) return null;

    // `all` and `frontpage` are catch-alls and are never in the payload, so they
    // fall out at the membership check below rather than needing a case here.
    return decodeURIComponent(match[1]).toLowerCase();
  }

  function apply() {
    var nav = document.querySelector('[data-hp-crumb-collections]');
    if (!nav) return;

    var link = nav.querySelector('[data-hp-crumb="collection"] a');
    if (!link) return;

    var handle = referringCollectionHandle();
    if (!handle) return;

    var collections;
    try {
      collections = JSON.parse(nav.getAttribute('data-hp-crumb-collections'));
    } catch (e) {
      return;
    }

    var match = collections && collections[handle];
    if (!match || !match.title || !match.url) return;

    // Already the crumb the server chose. Skipping keeps the DOM untouched on
    // the common path, where the pinned collection and the referrer agree.
    if (link.getAttribute('href') === match.url) return;

    link.textContent = match.title;
    link.setAttribute('href', match.url);
  }

  apply();
})();
